/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/communication/remediumApi"/>
import {
    get as platformGet,
    post as platformPost,
    postMultipart as platformPostMultipart,
    put as platformPut,
    putMultipart as platformPutMultipart,
    del as platformDel,
    Data,
} from "Core/Medius.Core.Web/Scripts/Medius/core/communication/platform";
import { redirectUnauthorized } from "Core/Medius.Core.Web/Scripts/Medius/core/redirect";

export async function post<T = any>(url: string, data?: Data) {
    return platformPost(url, data)
        .then(redirectUnauthorized)
        .then(throwResponseError) as Promise<T>;
}

export async function postMultipart<T = any>(url: string, data: FormData) {
    return platformPostMultipart(url, data)
        .then(redirectUnauthorized)
        .then(throwResponseError) as Promise<T>;
}

export async function put<T = any>(url: string, data?: Data) {
    return platformPut(url, data)
        .then(redirectUnauthorized)
        .then(throwResponseError) as Promise<T>;
}

export async function putMultipart<T = any>(url: string, data: FormData) {
    return platformPutMultipart(url, data)
        .then(redirectUnauthorized)
        .then(throwResponseError) as Promise<T>;
}

export async function del<T = any>(url: string, data?: Data) {
    return platformDel(url, data)
        .then(redirectUnauthorized)
        .then(throwResponseError) as Promise<T>;
}

export async function get<T = any>(
    url: string,
    data: Data = {},
    optionOverrides: any = {}
) {
    return platformGet(url, data, optionOverrides)
        .then(redirectUnauthorized)
        .then(throwResponseError) as Promise<T>;
}

async function throwResponseError(response: Response) {
    if (!response.ok) throw response.clone();
    return response;
}
